/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../API';
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createAnnouncement = /* GraphQL */ `mutation CreateAnnouncement($input: AnnouncementInput) {
  createAnnouncement(input: $input) {
    announcement
    announcementCategory {
      id
      label
      labelType
    }
    announcementDate
    announcementLink
    applicationName {
      id
      label
      labelType
    }
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    title
  }
}
` as GeneratedMutation<APITypes.CreateAnnouncementMutationVariables, APITypes.CreateAnnouncementMutation>;
export const createApplication = /* GraphQL */ `mutation CreateApplication($input: ApplicationInput) {
  createApplication(input: $input) {
    applicationLink
    applicationName
    applicationOwnerId
    embeddingEnabled
    fullApplicationDescription
    glAccounts {
      id
      label
      labelType
    }
    hasNonProductionEnvironments
    id
    isFlagship
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    keyDimension {
      id
      label
      labelType
    }
    lastEnhanced {
      id
      label
      labelType
    }
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    nonProductionEnvironments {
      accessLevel {
        id
        label
        labelType
      }
      displayText
      id
      link
    }
    process {
      id
      label
      labelType
    }
    qChatConfig {
      agentUrl
      isEnabled
    }
    scenario {
      id
      label
      labelType
    }
    shortApplicationDescription
    timeGranularity {
      id
      label
      labelType
    }
    toolUI {
      id
      label
      labelType
    }
    urlName
  }
}
` as GeneratedMutation<APITypes.CreateApplicationMutationVariables, APITypes.CreateApplicationMutation>;
export const createFeedback = /* GraphQL */ `mutation CreateFeedback($input: FeedbackInput) {
  createFeedback(input: $input) {
    applicationName {
      id
      label
      labelType
    }
    feedback
    feedbackType
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    rating
  }
}
` as GeneratedMutation<APITypes.CreateFeedbackMutationVariables, APITypes.CreateFeedbackMutation>;
export const createGeneralContent = /* GraphQL */ `mutation CreateGeneralContent($input: GeneralContentInput) {
  createGeneralContent(input: $input) {
    content
    id
    name
  }
}
` as GeneratedMutation<APITypes.CreateGeneralContentMutationVariables, APITypes.CreateGeneralContentMutation>;
export const createOrUpdateApplicationFavorites = /* GraphQL */ `mutation CreateOrUpdateApplicationFavorites($input: FavoriteInput) {
  createOrUpdateApplicationFavorites(input: $input) {
    applicationId
    id
    userAlias
  }
}
` as GeneratedMutation<APITypes.CreateOrUpdateApplicationFavoritesMutationVariables, APITypes.CreateOrUpdateApplicationFavoritesMutation>;
export const createOrUpdateLabels = /* GraphQL */ `mutation CreateOrUpdateLabels($input: [LabelInput]) {
  createOrUpdateLabels(input: $input) {
    id
    label
    labelType
  }
}
` as GeneratedMutation<APITypes.CreateOrUpdateLabelsMutationVariables, APITypes.CreateOrUpdateLabelsMutation>;
export const createOrUpdateMapping = /* GraphQL */ `mutation CreateOrUpdateMapping($input: [MappingInput], $table_name: String) {
  createOrUpdateMapping(input: $input, table_name: $table_name) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<APITypes.CreateOrUpdateMappingMutationVariables, APITypes.CreateOrUpdateMappingMutation>;
export const deleteApplication = /* GraphQL */ `mutation DeleteApplication($input: [ApplicationInput]) {
  deleteApplication(input: $input)
}
` as GeneratedMutation<APITypes.DeleteApplicationMutationVariables, APITypes.DeleteApplicationMutation>;
export const deleteFinanceCalendarEvent = /* GraphQL */ `mutation DeleteFinanceCalendarEvent($eventId: String!) {
  deleteFinanceCalendarEvent(eventId: $eventId)
}
` as GeneratedMutation<APITypes.DeleteFinanceCalendarEventMutationVariables, APITypes.DeleteFinanceCalendarEventMutation>;
export const fingenieAction = /* GraphQL */ `mutation FingenieAction($input: FinGenieActionInput!) {
  fingenieAction(input: $input) {
    metadata {
      agentAliasId
      agentId
      conversationId
      messageId
      source
      usage {
        inputTokens
        outputTokens
        totalTokens
      }
    }
    response
    sessionId
    status
    timestamp
  }
}
` as GeneratedMutation<APITypes.FingenieActionMutationVariables, APITypes.FingenieActionMutation>;
export const putFinanceCalendarEvents = /* GraphQL */ `mutation PutFinanceCalendarEvents($events: [FinanceCalendarEventInput!]!) {
  putFinanceCalendarEvents(events: $events) {
    dateTime
    description
    event
    eventId
    scenario
    source
  }
}
` as GeneratedMutation<APITypes.PutFinanceCalendarEventsMutationVariables, APITypes.PutFinanceCalendarEventsMutation>;
export const updateAnnouncement = /* GraphQL */ `mutation UpdateAnnouncement($input: AnnouncementInput) {
  updateAnnouncement(input: $input) {
    announcement
    announcementCategory {
      id
      label
      labelType
    }
    announcementDate
    announcementLink
    applicationName {
      id
      label
      labelType
    }
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    title
  }
}
` as GeneratedMutation<APITypes.UpdateAnnouncementMutationVariables, APITypes.UpdateAnnouncementMutation>;
export const updateApplication = /* GraphQL */ `mutation UpdateApplication($input: ApplicationInput) {
  updateApplication(input: $input) {
    applicationLink
    applicationName
    applicationOwnerId
    embeddingEnabled
    fullApplicationDescription
    glAccounts {
      id
      label
      labelType
    }
    hasNonProductionEnvironments
    id
    isFlagship
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    keyDimension {
      id
      label
      labelType
    }
    lastEnhanced {
      id
      label
      labelType
    }
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    nonProductionEnvironments {
      accessLevel {
        id
        label
        labelType
      }
      displayText
      id
      link
    }
    process {
      id
      label
      labelType
    }
    qChatConfig {
      agentUrl
      isEnabled
    }
    scenario {
      id
      label
      labelType
    }
    shortApplicationDescription
    timeGranularity {
      id
      label
      labelType
    }
    toolUI {
      id
      label
      labelType
    }
    urlName
  }
}
` as GeneratedMutation<APITypes.UpdateApplicationMutationVariables, APITypes.UpdateApplicationMutation>;
export const updateDasFinSumFeedback = /* GraphQL */ `mutation UpdateDasFinSumFeedback($input: DasFinSumFeedbackInput) {
  updateDasFinSumFeedback(input: $input)
}
` as GeneratedMutation<APITypes.UpdateDasFinSumFeedbackMutationVariables, APITypes.UpdateDasFinSumFeedbackMutation>;
export const updateFeedback = /* GraphQL */ `mutation UpdateFeedback($input: FeedbackInput) {
  updateFeedback(input: $input) {
    applicationName {
      id
      label
      labelType
    }
    feedback
    feedbackType
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    rating
  }
}
` as GeneratedMutation<APITypes.UpdateFeedbackMutationVariables, APITypes.UpdateFeedbackMutation>;
export const updateGeneralContent = /* GraphQL */ `mutation UpdateGeneralContent($input: [GeneralContentInput]) {
  updateGeneralContent(input: $input) {
    content
    id
    name
  }
}
` as GeneratedMutation<APITypes.UpdateGeneralContentMutationVariables, APITypes.UpdateGeneralContentMutation>;
export const updateHomePageContent = /* GraphQL */ `mutation UpdateHomePageContent($input: HomePageContentInput) {
  updateHomePageContent(input: $input) {
    applicationBanner {
      action {
        label
        url
      }
      bannerType
      content
      dismissible
      header
      isEnabled
    }
    contactsWidgetContacts {
      contactId
      groupName
      otherContacts {
        contactAlias
        contactName
      }
      primaryContact {
        contactAlias
        contactName
      }
      simLinks {
        name
        url
      }
      slackChannels {
        name
        url
      }
    }
    hasWelcomeContent
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    welcomeContentDetails {
      description
      displayText
      id
      link
      pointOfContact
    }
    welcomeTitle
  }
}
` as GeneratedMutation<APITypes.UpdateHomePageContentMutationVariables, APITypes.UpdateHomePageContentMutation>;
export const updateTeamPageContent = /* GraphQL */ `mutation UpdateTeamPageContent($input: TeamPageContentInput) {
  updateTeamPageContent(input: $input) {
    enableTeamInfoTabs
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    sidePanelDetails {
      customSidePanelWidgets {
        contentType
        id
        isEnabled
        isExpandedByDefault
        richTextContent
        tableContent {
          displayName
          id
          link
          position
        }
        title
      }
      keyContacts {
        contentType
        isEnabled
        isExpandedByDefault
        richTextContent
        title
      }
      officeHours {
        contentType
        isEnabled
        isExpandedByDefault
        richTextContent
        title
      }
      supportLinks {
        contentType
        id
        isEnabled
        isExpandedByDefault
        richTextContent
        tableContent {
          displayName
          id
          link
          position
        }
        title
      }
    }
    teams {
      id
      teamIntroductionVideoUrl
      teamName
      teamOverView
      teamWelcomeDetails {
        description
        displayText
        id
        link
        pointOfContact
      }
    }
  }
}
` as GeneratedMutation<APITypes.UpdateTeamPageContentMutationVariables, APITypes.UpdateTeamPageContentMutation>;

export const createMcpConfig = /* GraphQL */ `mutation CreateMcpConfig($input: McpConfigInput!) {
  createMcpConfig(input: $input) {
    id
    name
    description
    category
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    terminalCommands {
      os
      method
      command
    }
    resources {
      label
      url
      type
    }
    toolGroups {
      category
      tools {
        name
        description
      }
    }
    features {
      icon
      title
      description
    }
    contacts {
      alias
      role
    }
    isFeatured
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
}
` as GeneratedMutation<any, any>;
export const updateMcpConfig = /* GraphQL */ `mutation UpdateMcpConfig($input: McpConfigInput!) {
  updateMcpConfig(input: $input) {
    id
    name
    description
    category
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    terminalCommands {
      os
      method
      command
    }
    resources {
      label
      url
      type
    }
    toolGroups {
      category
      tools {
        name
        description
      }
    }
    features {
      icon
      title
      description
    }
    contacts {
      alias
      role
    }
    isFeatured
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
}
` as GeneratedMutation<any, any>;
export const deleteMcpConfig = /* GraphQL */ `mutation DeleteMcpConfig($id: String!) {
  deleteMcpConfig(id: $id)
}
` as GeneratedMutation<any, any>;
